import React, { useState } from 'react';
import { Button, ButtonProps } from '@lifeomic/chroma-react/components/Button';
import { defineMessages, useIntl } from 'react-intl';
import {
  LifeologyCourseProps,
  LifeologyCourse,
  CourseState,
} from './LifeologyCourse';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { getTestProps } from '../../util/testProps';
import {
  hideSurveyCloseButton,
  showSurveyCloseButton,
} from '../../util/reactNative';

const messages = defineMessages({
  modalTitleDefault: {
    id: 'lifeology.course.modalTitleDefault',
    defaultMessage: 'Lifeology Course',
  },
  buttonTitleDefault: {
    id: 'lifeology.course.launchButtonDefault',
    defaultMessage: 'Launch Course',
  },
});

export const testIds = {
  launchButton: 'lifeologyCourse-launchButton',
  modal: 'lifeologyCourse-launchButton-modal',
};

const useStyles = makeStyles(() => ({
  modalContent: {
    padding: 0,
    overflow: 'hidden',
  },
}));

export type LaunchCourseButtonOwnProps = {
  modalTitle?: string;
  launchButtonTitle?: string;
  hideMobileSurveyCloseButton?: boolean;
};

export type LaunchCourseButtonProps = LaunchCourseButtonOwnProps &
  LifeologyCourseProps &
  ButtonProps;

export const LaunchCourseButton = (props: LaunchCourseButtonProps) => {
  const [isLaunched, setIsLaunched] = useState(false);

  const {
    modalTitle,
    launchButtonTitle,
    url,
    onCourseStateUpdate,
    hideMobileSurveyCloseButton,
    ...toPass
  } = props;
  const formatMessage = useIntl().formatMessage;

  const launch = () => {
    if (hideMobileSurveyCloseButton) {
      hideSurveyCloseButton();
    }
    setIsLaunched(true);
  };

  const handleCourseExit = (state: CourseState) => {
    if (state === CourseState.Exited) {
      if (hideMobileSurveyCloseButton) {
        showSurveyCloseButton();
      }
      setIsLaunched(false);
    }
    if (onCourseStateUpdate) {
      onCourseStateUpdate(state);
    }
  };

  const handleModalClose = () => {
    if (hideMobileSurveyCloseButton) {
      showSurveyCloseButton();
    }
    setIsLaunched(false);
  };

  const classes = useStyles({});

  return (
    <React.Fragment>
      <Button
        {...getTestProps(testIds.launchButton)}
        {...toPass}
        onClick={launch}
      >
        {launchButtonTitle || formatMessage(messages.buttonTitleDefault)}
      </Button>
      <Modal
        {...getTestProps(testIds.modal)}
        isOpen={!!isLaunched}
        isFullScreen
        title={modalTitle || formatMessage(messages.modalTitleDefault)}
        onDismiss={handleModalClose}
        fullWidth={true}
        contentClassName={classes.modalContent}
      >
        <LifeologyCourse onCourseStateUpdate={handleCourseExit} url={url} />
      </Modal>
    </React.Fragment>
  );
};
